<template>
  <button
    @click="toggle"
    class="flex items-center justify-center w-11 h-11 rounded-full bg-white border border-[#DCDCDC] dark:bg-[#3A3A3A] dark:border-none"
  >
    <div v-if="colorMode.unknown" class="w-6 h-6"></div>

    <img
      v-else-if="colorMode.value === 'dark'"
      src="@/assets/icons/sun.svg"
      alt="Switch to light mode"
      class="w-6 h-6"
    />

    <img
      v-else
      src="@/assets/icons/moon.svg"
      alt="Switch to dark mode"
      class="w-6 h-6"
    />
  </button>
</template>

<script setup>
const colorMode = useColorMode();
const toggle = () => {
  colorMode.preference = colorMode.value === "dark" ? "light" : "dark";
};
</script>
